<div class="headline has-text-centered">
    <h1 *ngIf="!firstName">Hallo!</h1>
    <h1 *ngIf="firstName">Hallo, <span class="is-bold" data-cy="name">{{ firstName }}!</span> </h1>
    <p class="has-font-400 color-grey-500" id="cy-welcome">Herzlich willkommen.</p>
</div>